<template>
    <div>
        <div class="modal fade" id="modal-filemanager" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="col-md-11">
                            <h5><b>Gerenciador de arquivos</b></h5>
                        </div>
                        <div class="col-md-1">
                            <button type="button" class="close" id="close-modal" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12">
                                    <br/>
                                    <label class="btn btn-primary btn-block" style="padding: 8px;">
                                        <i class="fa fa-upload"></i> Fazer upload <input class="hidden" type="file" accept="image/*" @change="changeFileUpload"/>
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <DxFileManager
                                        root-folder-name="Todas as pastas"
                                        :show-panel="false"
                                        :file-system-provider="getFolders"
                                        :on-selected-file-opened="changeFile"
                                        :customize-thumbnail="customizeIcon"
                                        :on-current-directory-changed="onFolderClick"
                                        :current-path='this.directoryInitialize'
                                        :height="600">

                                        <DxItemView mode="thumbnails"/>
                                        <DxPermissions
                                            :create="false"
                                            :copy="false"
                                            :move="false"
                                            :delete="false"
                                            :rename="false"
                                            :upload="false"
                                            :download="false"
                                        />
                                    </DxFileManager>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import 'devextreme/dist/css/dx.light.css';
    import { DxFileManager, DxPermissions, DxItemView } from 'devextreme-vue/file-manager';
    import { DxPopup } from 'devextreme-vue/popup';
    import { mapGetters } from "vuex";
    import axios from "axios";
    import Swal from "sweetalert2";
    import store from '../../store';

    export default {
        name: 'c-atlas-filemanager',

        components: {
            DxFileManager,
            DxPermissions,
            DxPopup,
            DxItemView
        },

        data() {
            return {
                currentDirectory: '',
                directoryInitialize: '',
                endPointUpload: '/file-manager-atlas/new-buscar-pastas-arquivos',
                remoteProvider: this.getFolders,
                popupVisible: false,
                appRoot: _ROOT_PATH + '/'
            };
        },

        computed: {
            ...mapGetters({getFolders: 'folders/getFoldersFileManager'})
        },

        methods: {
            customizeIcon(fileSystemItem) {
                const fileExtension = fileSystemItem.getFileExtension();
                if(fileSystemItem.dataItem) {
                    switch (fileExtension) {
                        case '.jpg':
                            return this.appRoot + fileSystemItem.dataItem.url;
                        case '.jpeg':
                            return this.appRoot + fileSystemItem.dataItem.url;
                        case '.png':
                            return this.appRoot + fileSystemItem.dataItem.url;
                        case '.webp':
                            return this.appRoot + fileSystemItem.dataItem.url;
                        default:
                            return '';
                    }
                }
            },

            changeFile(e) {
                this.$emit('fileSelected', {
                    name: e.file.name,
                    url: this.appRoot + e.file.dataItem.url,
                });
            },

            changeFileUpload (event) {
                if (event.target.files[0]) {
                    let formData = new FormData();
                    formData.append('file', event.target.files[0]);
                    formData.append('folder_id', this.currentDirectory);
                    var _this = this;
                    axios.post(
                        _ROOT_PATH + '/admin/file-manager-atlas/upload-de-arquivos',
                        formData,
                        {headers: {'Content-Type': 'multipart/form-data'}})
                        .then(function (response) {
                            console.log(response);
                            store.commit("folders/populateFolders");
                        })
                        .catch(function (error) {
                            Swal.fire({
                                title: 'Oops!',
                                text: 'Ocorreu um erro ao realizar o upload, verifique sua internet e tente novamente!',
                                type: 'error',
                                confirmButtonColor: '#d63030',
                                confirmButtonText: 'Ok!'
                            });
                        });
                }
            },

            onFolderClick(e) {
                this.currentDirectory    = e.directory.dataItem.key;
                this.directoryInitialize = e.directory.path;
            }
        },
    };
</script>

<style>
    .dx-fileuploader-files-container {
        display: none;
    }
    .dx-filemanager {
        border: 0;
    }
    .dx-filemanager-toolbar.dx-filemanager-general-toolbar {
        display: none;
    }
</style>